import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { AuthService } from 'app/services/auth.service';
import { ProjectService } from 'app/services/models/project.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProjectListComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any[] = [];
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption = 5;
  public searchValue = '';
  totalCount: number = 0;
  public ColumnMode = ColumnMode;

  projectId: number = null
  constructor(
    private projectService: ProjectService,
    private router: Router, 
    private _coreSidebarService: CoreSidebarService,
    public authService:AuthService) { }

  async ngOnInit() {
    this.projectService.event$.subscribe(async result => {
      await this.getAllProject(this.pageBasic - 1, this.selectedSize, this.searchValue,this.selectedStatus);
    })
    await this.getAllProject(this.pageBasic - 1, this.selectedSize, this.searchValue,this.selectedStatus);
  }

  onActivate(event: any) {
    const projectDetailAuthorization = this.authService.isEndpointStatus('GET.Reading.GetByIdProject');
    if(projectDetailAuthorization){
      if (event.type === 'click' && event.row) {
        this.router.navigate([`/admin/project-detail/${event.row.id}`]);
      }
    }
  }

  async getAllProject(page, size, search,status) {
    this.blockUI.start('Projeler yükleniyor...');
    const projectAuthorization = this.authService.isEndpointStatus('GET.Reading.GetAllProject');
    if(projectAuthorization){
      const data = await this.projectService.getAllProject(page, size, search,status);
      console.log(data);
      this.rows = data.projects;
      this.totalCount = data.totalCount;  
    }
    this.blockUI.stop();
  }

  async filterUpdate(event: Event) {
    const input = event.target as HTMLInputElement;
    this.searchValue = input.value.toLowerCase();
    console.log(this.searchValue);
    await this.getAllProject(this.pageBasic - 1, this.selectedSize, this.searchValue,this.selectedStatus);
  }

  async onPageChange() {
    await this.getAllProject(this.pageBasic - 1, this.selectedSize, this.searchValue,this.selectedStatus);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption);
    await this.getAllProject(this.pageBasic - 1, this.selectedSize, this.searchValue,this.selectedStatus);
  }

  toggleSidebar(event: MouseEvent, name, id): void {
    event.stopPropagation();
    this.projectId = id;
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  selectedStatus:any = null;
  status = [
    { id: 1, name: "Devam Ediyor" },
    { id: 2, name: "İptal Edildi" },
    { id: 3, name: "Tamamlandı" }
  ]

  getByStatusName(status) {
    const stat = this.status.find(s => s.id == status);
    return stat?.name;
  }

  getBySatusClass(status) {
    switch (status) {
      case 1:
        return "badge-primary";
      case 2:
        return "badge-danger";
      case 3:
        return "badge-success"
    }
  }

  async filterByStatus(event) {
    const filter = event.id;
    console.log(filter);
    this.selectedStatus = filter;
    await this.getAllProject(this.pageBasic - 1, this.selectedSize, this.searchValue, this.selectedStatus);
  }

  async onClear(){
    await this.getAllProject(this.pageBasic - 1, this.selectedSize, this.searchValue, this.selectedStatus);
  }
}